import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authActions from "../../redux/auth/actions";
import bellIcon from "../../assets/icons/icon.svg";
import "./header.scss";
import { IoNotifications } from "react-icons/io5";
import {
  Dropdown,
  Tooltip,
  Input,
  Form,
  Button,
  Modal,
  message,
  ConfigProvider,
  Popover,
} from "antd";
// import Cookies from "js-cookie";
import orgPng from "../../assets/images/org.png";
import mailpng from "../../assets/images/mail (1).png";
import resetPasswordpng from "../../assets/images/reset-password (1).png";
import logoutpng from "../../assets/images/log-out.png";
import { PASSWORD_VALIDATE } from "../../Helpers/Constane";
import { CloseCircleOutlined } from "@ant-design/icons";
import id from "../../assets/images/id.png";
import loader from "../../assets/images/refresh.png";
import money from "../../assets/images/money.webp";
// import actions from "../../redux/auth/actions";
import { TailSpin } from "react-loader-spinner";
const { getProfile, changePassword, authReset, getAgentInfo } = authActions;

function Header() {
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const bankLogo = process.env.REACT_APP_IDFC_LOGO;
  const profileData = useSelector((state) => state.authReducer.profileData);
  console.log("real profileeeeeeeeeee", profileData);
  const { loading, agentInformation } = useSelector(
    (state) => state.authReducer
  );
  const [newAgentInformation, setNewAgentInformation] = useState(null);

  const changePasswordMessage = useSelector(
    (state) => state.authReducer.changePasswordMessage
  );
  const changePasswordError = useSelector(
    (state) => state.authReducer.changePasswordError
  );
  const buttonLoading = useSelector((state) => state.authReducer.buttonLoading);
  const [open, setOpen] = useState(false);
  const [passwordFormate, setPasswordFormate] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [viewedNotifications, setViewedNotifications] = useState([]);
  const [ProfileAgentId, setProfileAgentId] = useState(null);

  const data = [];

  useEffect(() => {
    if (viewedNotifications?.length > 0) {
      setNotifications(data?.filter((i) => !viewedNotifications?.includes(i)));
    } else {
      setNotifications(data);
    }
  }, [viewedNotifications]);

  const handleLogOut = () => {
    sessionStorage.removeItem("biller_access");
    localStorage.removeItem("module_access");
    window.location.href = "/login";
    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    if (profileData?.orgId) {
      dispatch(getAgentInfo(profileData?.orgId));
    }
  }, [profileData?.orgId]);

  console.log("mew informationnnnnnnnnnnnnnnnnnnnnnnnnn", newAgentInformation);

  useEffect(() => {
    if (changePasswordMessage !== null && changePasswordMessage !== undefined) {
      success(changePasswordMessage);
    }
    if (changePasswordError !== null && changePasswordError !== undefined) {
      errorHandle(changePasswordError);
    }
  }, [changePasswordMessage, changePasswordError]);

  const success = (text) => {
    setOpen(false);
    const hide = messageApi.open({
      type: "success",
      content: text,
    });
    setTimeout(hide, 4000);
    dispatch(authReset());
  };
  const errorHandle = (text) => {
    const hide = messageApi.open({
      type: "error",
      content: text,
    });
    setTimeout(hide, 4000);
    dispatch(authReset());
  };

  const handleOpenPasswordFormModal = () => {
    setOpen(true);
  };

  const handlePassword = (e) => {
    e.preventDefault();
    if (PASSWORD_VALIDATE.test(e.target.value) || e.target.value === "") {
      setPasswordFormate(true);
    } else {
      setPasswordFormate(false);
    }
  };

  const handleRefreshProfile = (e) => {
    e.stopPropagation(); // prevents Dropdown from closing
    dispatch(getAgentInfo(profileData?.orgId));
  };

  const handleSubmit = (values) => {
    dispatch(changePassword(values));
  };

  // const callAgentInfoApi = () => {
  //   dispatch(getAgentInfo(profileData?.orgId));
  // };

  useEffect(() => {
    if (agentInformation?.data) {
      setNewAgentInformation(agentInformation);
    }
  }, [agentInformation?.data]);

  const items = [
    {
      key: 1,
      label: (
        <div className="profileWrapper">
          <div className="profile">
            <div className="circle" style={{ cursor: "pointer" }}>
              <p className="circle-inner-profile">
                {profileData ? profileData?.name?.charAt(0).toUpperCase() : ""}
              </p>
            </div>
            <h3 className="name-profile">{profileData?.name}</h3>
            <p className="title">{profileData?.role}</p>
          </div>
          <div className="email-content">
            <span>
              <img src={orgPng} alt="" width="19" height="19" />
            </span>
            <span className="gmail-p">
              <span>{newAgentInformation?.data?.agentName}</span>
            </span>
          </div>

          <div className="email-content">
            <span style={{ fontSize: "14px", color: "gray" }}>
              <img src={id} alt="" width="19" height="19" />
            </span>
            <span className="gmail-p">
              <span>{profileData?.orgId}</span>
            </span>
          </div>

          <div className="email-content">
            <span>
              <img src={mailpng} alt="" width="19" height="19" />
            </span>
            <span className="gmail-p">
              {" "}
              <a href={`mailto:${profileData?.email}`}>{profileData?.email}</a>
            </span>
          </div>

          {["super admin", "owner", "master admin"].includes(
            profileData.role
          ) && (
            <div
              className="email-content"
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
              onClick={(e) => handleRefreshProfile(e)}
            >
              <div>
                <span>
                  <img src={money} alt="" width="22" height="19" />
                </span>
                <span className="gmail-p">
                  <span>{newAgentInformation?.data?.balance.bank} ₹</span>
                </span>
              </div>

              <div>
                {agentInformation.loading ? (
                  <span>
                    <TailSpin
                      visible={true}
                      height="21"
                      width="21"
                      color="gray"
                      ariaLabel="tail-spin-loading"
                      radius="3"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </span>
                ) : (
                  <img src={loader} alt="" width="16" height="16" />
                )}
              </div>
            </div>
          )}

          <div className="social-icons">
            <div
              className="email-content"
              onClick={handleOpenPasswordFormModal}
            >
              <span>
                <img src={resetPasswordpng} alt="" width="19" height="19" />
              </span>
              <span className="gmail-p"> Change Password</span>
            </div>

            <div className="email-content" onClick={handleLogOut}>
              <span>
                <img src={logoutpng} alt="" width="19" height="19" />
              </span>
              <span className="gmail-p"> Log Out</span>
            </div>
          </div>
        </div>
      ),
    },
  ];

  const notificationData = (
    <>
      {notifications.filter((i) => !viewedNotifications?.includes(i))?.length >
      0 ? (
        <div className="notificationsData">
          {notifications?.map((i, index) => (
            <div className="notification-item" key={index}>
              <span>{i}</span>
              <CloseCircleOutlined
                onClick={() => {
                  if (!viewedNotifications?.includes(i)) {
                    setViewedNotifications((prevViewedNotifications) => [
                      ...prevViewedNotifications,
                      i,
                    ]);
                  }
                }}
              />
            </div>
          ))}
        </div>
      ) : (
        <span className="notificationsData">No New Notification</span>
      )}
    </>
  );

  return (
    <div className="AppHeader">
      {contextHolder}
      <div>
        <img className="logoIcon" src='./idfc_first_bank.png' alt="IDFC logo"></img>
      </div>
      <div className="alignNotification">
        <Popover
          content={notificationData}
          title={`Notifications (${
            notifications?.filter((i) => !viewedNotifications?.includes(i))
              ?.length
          })`}
          trigger={"click"}
        >
          <div style={{ cursor: "pointer" }}>
            {notifications && notifications?.length > 0 ? (
              <img className="imgIcon" src={bellIcon} alt="notification"></img>
            ) : (
              <IoNotifications size={25} />
            )}
          </div>
        </Popover>

        <Dropdown menu={{ items }} placement="topRight" trigger={["click"]}>
          <div className="circle" style={{ cursor: "pointer" }}>
            <p className="circle-inner">
              {profileData ? profileData?.name?.charAt(0).toUpperCase() : ""}
            </p>
          </div>
        </Dropdown>
      </div>

      <Modal
        title="Change Password"
        open={open}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={true}
        destroyOnClose={true}
        maskClosable={false}
        centered
        footer={[
          <Button key="back" onClick={handleCancel}>
            CANCEL
          </Button>,
          <Button
            form="passwordForm"
            key="submit"
            htmlType="submit"
            type="primary"
            loading={buttonLoading}
          >
            UPDATE
          </Button>,
        ]}
      >
        <Form
          id="passwordForm"
          onFinish={handleSubmit}
          layout="vertical"
          className="row-col"
        >
          <ConfigProvider>
            <Tooltip
              placement="bottom"
              title={
                "Password must be at least 12 characters, including at least one uppercase (A), one lowercase (a), one special character (#), and digits (12345)."
              }
            >
              <Form.Item
                className="username"
                label="New Password"
                name="password"
                rules={[
                  { required: true, message: "New password is required!" },
                  {
                    validator(_, value) {
                      if (passwordFormate === true) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Invalid password format!")
                      );
                    },
                  },
                ]}
              >
                <Input.Password
                  placeholder="New Password"
                  name="password"
                  hasFeedback
                  onChange={handlePassword}
                />
              </Form.Item>
            </Tooltip>
          </ConfigProvider>

          <Form.Item
            className="username"
            label="Confirm Password"
            name="confirmPassword"
            hasFeedback
            rules={[
              { required: true, message: "Confirm password is required!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Confirm password does not match!")
                  );
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Confirm Password"
              name="confirmPassword"
              onChange={handlePassword}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default Header;
